window.bundleOptions = document.querySelectorAll('.js-bundle-option');
window.bundleAddToCartButtons = document.querySelectorAll('.js-bundle-add-to-cart');

// Select all color option inputs and swiper images
window.colorOptionInputs = document.querySelectorAll('.option-values.color-options input');
window.swiperImages = document.querySelectorAll('.product__media-wrapper .swiper-wrapper .swiper-slide img');

// Add click event listeners to each color option input
colorOptionInputs.forEach(input => {
    if (input.checked) handleColorOptionClick(input);
    input.addEventListener('click', handleColorOptionClick);
});

// Handle the click event for color options
function handleColorOptionClick(event) {
    const selectedValue = event?.value || event?.target?.value;
    if (!selectedValue) return;

    const waitForSwiperImages = setInterval(() => {
        if (swiperImages.length > 0) {
            clearInterval(waitForSwiperImages);
            swiperImages.forEach(image => {
                const dataVariants = image.getAttribute('data-variants');
                if (!dataVariants) return;

                if (dataVariants.toLowerCase() === selectedValue.toLowerCase()) {
                    const slide = image.closest('.swiper-slide');
                    const wrapper = slide && slide.parentElement;
                    const slideIndex = wrapper ? Array.prototype.indexOf.call(wrapper.children, slide) : -1;

                    if (slideIndex > -1 && window.currentProductMediaGallery?.mainSwiper) {
                        window.currentProductMediaGallery.mainSwiper.slideTo(slideIndex);
                        if (window.currentProductMediaGallery.thumbnailSwiper) {
                            window.currentProductMediaGallery.thumbnailSwiper.slideTo(slideIndex);
                        }
                    }
                }
            });
        }
    }, 100);
}

// Store selected options for each bundle
window.selectedOptions = {};

// Extract free shipping threshold from product tags if available
window.freeShippingThreshold = null;
if (productTags && Array.isArray(productTags)) {
    for (const tag of productTags) {
        if (tag.startsWith('free_shipping_over_')) {
            const thresholdStr = tag.replace('free_shipping_over_', '');
            freeShippingThreshold = parseFloat(thresholdStr) * 100; // Convert to cents
            break;
        }
    }
}

// Initialize with default selections
document.querySelectorAll('.related-bundle').forEach(bundle => {
    const addToCartButton = bundle.querySelector('.js-bundle-add-to-cart');
    if (!addToCartButton) return;

    const bundleId = addToCartButton.dataset.bundleId;
    selectedOptions[bundleId] = {
        1: bundle.querySelector('[data-option-index="1"]:checked')?.dataset.optionValue,
        2: bundle.querySelector('[data-option-index="2"]:checked')?.dataset.optionValue
    };

    // Update selected value displays
    updateSelectedValueDisplays(bundleId);

    // Find and display initial variant
    updateSelectedVariant(bundleId);
});

bundleOptions.forEach(option => {
    option.addEventListener('change', function(event) {
        if (event && event.isTrusted !== false) {
            window.EG_PDP_VARIANT_INTERACTED = true;
        }
        const bundleId = this.dataset.bundleId;
        const optionIndex = this.dataset.optionIndex;
        const optionValue = this.dataset.optionValue;

        // Update selected options
        selectedOptions[bundleId][optionIndex] = optionValue;

        // Update selected value displays
        updateSelectedValueDisplays(bundleId);

        // Find and display selected variant
        updateSelectedVariant(bundleId);
    });
});

function updateSelectedValueDisplays(bundleId) {
    for (let i = 1; i <= 2; i++) {
        const displayElement = document.getElementById(`bundle-${bundleId}-option${i}-selected`);
        if (displayElement && selectedOptions[bundleId][i]) {
            if (i === 1) {
                displayElement.textContent = selectedOptions[bundleId][i];
            } else {
                displayElement.textContent = selectedOptions[bundleId][i] + " Pack";
            }
        }
    }
}

function updateSelectedVariant(bundleId) {
    // Get all variants for this bundle
    const variantsJson = document.getElementById(`bundle-${bundleId}-variants`).textContent;
    const variants = JSON.parse(variantsJson);

    // Find the variant that matches our selected options
    const selectedVariant = variants.find(variant => {
        return variant.option1 === selectedOptions[bundleId][1] &&
            variant.option2 === selectedOptions[bundleId][2];
    });

    if (selectedVariant) {
        // Find matching product variant to update the image
        const matchingProductVariant = findMatchingProductVariant(selectedVariant);
        if (matchingProductVariant) {
            updateUrlWithVariant(matchingProductVariant.id);
        }

        // Update price
        const priceElement = document.getElementById(`bundle-${bundleId}-price`);
        if (priceElement) {
            priceElement.textContent = formatMoney(selectedVariant.price);
        }

        // Update compare price if exists
        const comparePriceElement = document.getElementById(`bundle-${bundleId}-compare-price`);
        if (comparePriceElement) {
            if (selectedVariant.compare_at_price) {
                comparePriceElement.textContent = formatMoney(selectedVariant.compare_at_price);
                comparePriceElement.style.display = 'block';
                priceElement.classList.remove('not-compare-price');
                // Calculate and display discount percentage
                const discountPercentage = Math.round((selectedVariant.compare_at_price - selectedVariant.price) * 100 / selectedVariant.compare_at_price);
                const discountElement = document.querySelector(`.related-bundle-variant-discount[data-bundle-id="${bundleId}"]`);
                if (discountElement && discountPercentage > 0) {
                    discountElement.textContent = `${discountPercentage}% Off`;
                    discountElement.style.display = 'block';
                } else if (discountElement) {
                    discountElement.style.display = 'none';
                }
            } else {
                comparePriceElement.style.display = 'none';
                priceElement.classList.add('not-compare-price');
                // Hide discount percentage if no compare price
                const discountElement = document.querySelector(`.related-bundle-variant-discount[data-bundle-id="${bundleId}"]`);
                if (discountElement) {
                    discountElement.style.display = 'none';
                }
            }
        }

        // Update image if exists
        if (selectedVariant.featured_image) {
            const imageElement = document.getElementById(`bundle-${bundleId}-image`);
            if (imageElement) {
                imageElement.src = selectedVariant.featured_image.src.replace(/(\.[^.]*)$/, '_300x$1');
            }
        }

        // Update add to cart button
        const addToCartButton = document.querySelector(`.js-bundle-add-to-cart[data-bundle-id="${bundleId}"]`);
        if (addToCartButton) {
            // 1) update the variant id for cart‑building
            addToCartButton.dataset.variantId = selectedVariant.id;

            // 2) disable if truly unavailable
            addToCartButton.disabled = !selectedVariant.available;

            // 3) decide the label
            var isBirdies    = addToCartButton.dataset.productVendor === 'Birdies Beds';
            var oversellable = selectedVariant.inventory_policy === 'continue';

            if (isBirdies && oversellable) {
                addToCartButton.textContent = 'Pre‑Order';
            } else {
                addToCartButton.textContent = selectedVariant.available
                    ? 'Add to Cart'
                    : 'Sold Out';
            }
        }


        // Update free shipping display if threshold exists
        if (freeShippingThreshold !== null) {
            const freeshippingElements = document.querySelectorAll(`.related-bundle-option-free-shipping`);
            freeshippingElements.forEach(element => {
                // Get the closest label that contains this free shipping element
                const label = element.closest('label');
                if (label) {
                    // Extract the option value from the label's for attribute
                    const inputId = label.getAttribute('for');
                    const input = document.getElementById(inputId);
                    if (input) {
                        const optionValue = input.getAttribute('data-option-value');

                        // Find the variant for this specific option combination
                        const variantWithValue = variants.find(v =>
                            v.option1 === selectedOptions[bundleId][1] &&
                            v.option2 === optionValue
                        );

                        if (variantWithValue) {
                            // Show/hide based on price threshold
                            if (variantWithValue.price >= freeShippingThreshold) {
                                element.style.display = 'block';
                            } else {
                                element.style.display = 'none';
                            }
                        }
                    }
                }
            });
        }
    }

    // Update discount badges for each option2 value
    const option2Inputs = document.querySelectorAll(`.js-bundle-option[data-bundle-id="${bundleId}"][data-option-index="2"]`);

    // Find the best value (lowest price per unit) among all option2 variants
    let lowestPricePerUnit = Infinity;
    let bestValueOptionValue = null;

    // First pass: calculate price per unit for all options and find the lowest
    option2Inputs.forEach(input => {
        const optionValue = input.getAttribute('data-option-value');

        // Find variant with this option2 value and current option1
        const variantWithValue = variants.find(v =>
            v.option1 === selectedOptions[bundleId][1] &&
            v.option2 === optionValue
        );

        if (variantWithValue) {
            // Extract pack size from option value (e.g., "2 Pack" -> 2)
            const packSize = parseInt(optionValue);
            if (!isNaN(packSize) && packSize > 0) {
                const pricePerUnit = variantWithValue.price / packSize;
                if (pricePerUnit < lowestPricePerUnit) {
                    lowestPricePerUnit = pricePerUnit;
                    bestValueOptionValue = optionValue;
                }
            }
        }
    });

    // Second pass: update the UI for each option
    option2Inputs.forEach(input => {
        const optionValue = input.getAttribute('data-option-value');
        const label = document.querySelector(`label[for="${input.id}"]`);
        if (label) {
            const discountBadge = label.querySelector('.discount-badge');

            // Find variant with this option2 value and current option1
            const variantWithValue = variants.find(v =>
                v.option1 === selectedOptions[bundleId][1] &&
                v.option2 === optionValue
            );

            // console.log(optionValue);

            if (variantWithValue && variantWithValue.compare_at_price &&
                variantWithValue.compare_at_price > variantWithValue.price) {
                const discount = Math.round((variantWithValue.compare_at_price - variantWithValue.price) * 100 / variantWithValue.compare_at_price);

                if (discount > 0) {
                    if (discount === 25 && optionValue !== '4') {
                        if (discountBadge) {
                            const percentSpan = discountBadge.querySelector('.discount-percentage');
                            if (percentSpan) {
                                // percentSpan.textContent = `Buy 1 Get 1 50% Off`;
                                percentSpan.textContent = `25% Off`;
                            } else {
                                // discountBadge.innerHTML = `<span class="discount-percentage">${discount}% Off</span>`;
                            }
                            discountBadge.style.display = 'inline-block';
                        } else {
                            // If no discount badge exists, create one
                            const newBadge = document.createElement('div');
                            newBadge.className = 'discount-badge';
                            newBadge.innerHTML = `<span class="discount-percentage">25% Off</span>`;
                            label.insertBefore(newBadge, label.firstChild);
                        }
                    } else if (discount === 25 && optionValue === '4') {
                        // Create or update discount badge
                        if (discountBadge) {
                            const percentSpan = discountBadge.querySelector('.discount-percentage');
                            if (percentSpan) {
                                percentSpan.textContent = `25% Off`;
                            } else {
                                // discountBadge.innerHTML = `<span class="discount-percentage">${discount}% Off</span>`;
                            }
                            discountBadge.style.display = 'inline-block';
                        } else {
                            // If no discount badge exists, create one
                            const newBadge = document.createElement('div');
                            newBadge.className = 'discount-badge';
                            newBadge.innerHTML = `<span class="discount-percentage">25% Off</span>`;
                            label.insertBefore(newBadge, label.firstChild);
                        }
                    } else {
                        // Create or update discount badge
                        if (discountBadge) {
                            const percentSpan = discountBadge.querySelector('.discount-percentage');
                            if (percentSpan) {
                                percentSpan.textContent = `${discount}% Off`;
                            } else {
                                // discountBadge.innerHTML = `<span class="discount-percentage">${discount}% Off</span>`;
                            }
                            discountBadge.style.display = 'inline-block';
                        } else {
                            // If no discount badge exists, create one
                            const newBadge = document.createElement('div');
                            newBadge.className = 'discount-badge';
                            newBadge.innerHTML = `<span class="discount-percentage">${discount}% Off</span>`;
                            label.insertBefore(newBadge, label.firstChild);
                        }
                    }
                } else if (discountBadge) {
                    discountBadge.style.display = 'none';
                }
            } else if (discountBadge) {
                discountBadge.style.display = 'none';
            }

            // Add or remove "best-value" tag
            let bestValueTag = label.querySelector('.best-value-tag');
            if (optionValue === bestValueOptionValue) {
                if (!bestValueTag) {
                    bestValueTag = document.createElement('div');
                    bestValueTag.className = 'best-value-tag';
                    bestValueTag.innerHTML = '<span>Best Value</span>';

                    // Insert the best value tag in the tags container if it exists
                    const tagsContainer = label.querySelector('.related-bundle-option-3-tags');
                    if (tagsContainer) {
                        tagsContainer.appendChild(bestValueTag);
                    } else {
                        label.insertBefore(bestValueTag, label.firstChild);
                    }
                }
                bestValueTag.style.display = 'inline-block';
            } else if (bestValueTag) {
                bestValueTag.style.display = 'none';
            }
        }
    });

    // Update price each for option2 values
    option2Inputs.forEach(input => {
        const optionValue = input.getAttribute('data-option-value');
        const label = document.querySelector(`label[for="${input.id}"]`);
        if (label) {
            // Find variant with this option2 value and current option1
            const variantWithValue = variants.find(v =>
                v.option1 === selectedOptions[bundleId][1] &&
                v.option2 === optionValue
            );

            if (variantWithValue) {
                // Extract pack size from option value (e.g., "2" -> 2)
                const packSize = parseInt(optionValue);
                if (!isNaN(packSize) && packSize > 0) {
                    const priceEach = variantWithValue.price / packSize;
                    const priceEachElement = label.querySelector('.related-bundle-option-price-each');
                    if (priceEachElement) {
                        priceEachElement.innerHTML = `<span>${formatMoney(priceEach)}</span> <span> / each </span>`;
                    }
                }
            }
        }
    });
}

// Find matching product variant based on the same options
function findMatchingProductVariant(bundleVariant) {
    return productVariants.find(productVariant =>
        productVariant.option1 === bundleVariant.option1
    );
}

// Update the URL with the variant parameter
function updateUrlWithVariant(variantId) {
    if (!variantId) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);

    // Use history.replaceState to update the URL without a page reload
    window.history.replaceState({}, '', url.toString());

    // Trigger a change event on the variant selector to update images
    // This may be needed if your theme has a separate mechanism for updating images
    const variantSelectors = document.querySelectorAll('select[name="id"]');
    if (variantSelectors.length > 0) {
        variantSelectors.forEach(selector => {
            if (selector.value !== variantId.toString()) {
                selector.value = variantId;
                selector.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }
}

bundleAddToCartButtons.forEach(button => {
    button.addEventListener('click', function (e) {
        e.preventDefault();

        const variantId = this.dataset.variantId;
        if (!variantId) return;

        // Get cart element (same as product form does)
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);

        // If cart exists, append sections to render (like product form does)
        if (cart) {
            formData.append(
                'sections',
                cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            cart.setActiveElement(document.activeElement);
        }

        // Use the same fetch config as product form
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
            .then(response => response.json())
            .then(response => {
                if (response.status) {
                    // Handle error case
                    console.error('Cart add error:', response.description || response.message);
                    return;
                }

                if (!cart) return;

                // Publish cart update event (like product form does)
                if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'bundle-add-to-cart',
                        productVariantId: variantId,
                        cartData: response,
                    });
                }

                // Render cart contents and remove empty class
                cart.renderContents(response);
                if (cart.classList.contains('is-empty')) {
                    cart.classList.remove('is-empty');
                }

                // Open cart drawer if it exists
                if (document.querySelector('cart-drawer')) {
                    cart.open();
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    });
});

// Helper function to format money values
function formatMoney(cents) {
    const hideTrailingZeros = Boolean(document.querySelector('[data-epic-bed-v2]')) && cents % 100 === 0;
    return (cents / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: hideTrailingZeros ? 0 : 2,
        maximumFractionDigits: hideTrailingZeros ? 0 : 2
    });
}
